"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var sequences = {};
var DEFAULTS = {
  timestamp: function timestamp() {
    return function () {
      return Date.now();
    };
  },
  datetime: function datetime() {
    return function () {
      return new Date().toISOString();
    };
  },
  date: function date() {
    return function () {
      return new Date().toISOString().slice(0, 10);
    };
  },
  time: function time() {
    return function () {
      return new Date().toISOString().slice(11);
    };
  },
  random: function random() {
    return function () {
      return Math.random();
    };
  },
  randomint: function randomint(args) {
    var _a;

    var max = (_a = args === null || args === void 0 ? void 0 : args.max) !== null && _a !== void 0 ? _a : 2;
    return function () {
      return Math.floor(Math.random() * max);
    };
  },
  seq: function seq(args) {
    var _a;

    var name = (_a = args === null || args === void 0 ? void 0 : args.name) !== null && _a !== void 0 ? _a : "";
    sequences[name] || (sequences[name] = 0);
    return function () {
      return sequences[name]++;
    };
  }
};
var getDef = Object.assign(_getDef, {
  DEFAULTS: DEFAULTS
});

function _getDef() {
  return {
    keyword: "dynamicDefaults",
    type: "object",
    schemaType: ["string", "object"],
    modifying: true,
    valid: true,
    compile: function compile(schema, _parentSchema, it) {
      if (!it.opts.useDefaults || it.compositeRule) return function () {
        return true;
      };
      var fs = {};

      for (var key in schema) {
        fs[key] = getDefault(schema[key]);
      }

      var empty = it.opts.useDefaults === "empty";
      return function (data) {
        for (var prop in schema) {
          if (data[prop] === undefined || empty && (data[prop] === null || data[prop] === "")) {
            data[prop] = fs[prop]();
          }
        }

        return true;
      };
    },
    metaSchema: {
      type: "object",
      additionalProperties: {
        anyOf: [{
          type: "string"
        }, {
          type: "object",
          additionalProperties: false,
          required: ["func", "args"],
          properties: {
            func: {
              type: "string"
            },
            args: {
              type: "object"
            }
          }
        }]
      }
    }
  };
}

function getDefault(d) {
  return typeof d == "object" ? getObjDefault(d) : getStrDefault(d);
}

function getObjDefault(_ref) {
  var func = _ref.func,
      args = _ref.args;
  var def = DEFAULTS[func];
  assertDefined(func, def);
  return def(args);
}

function getStrDefault() {
  var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var def = DEFAULTS[d];
  assertDefined(d, def);
  return def();
}

function assertDefined(name, def) {
  if (!def) throw new Error("invalid \"dynamicDefaults\" keyword property value: ".concat(name));
}

exports.default = getDef;
module.exports = getDef;